
import { CFCDN } from "../../shop-front-component/ProductCollection";



export interface colourType {
    title: string;
    src: string;
}



// Blockout Fabrics
const Alaska = [{title:  "Ash", src: CFCDN + "Alaska/Ash.jpg"}, {title:  "Cinnamon", src: CFCDN + "Alaska/Cinnamon.jpg"}, {title:  "Cloud", src: CFCDN + "Alaska/Cloud.jpg"}, {title:  "Driftwood", src: CFCDN + "Alaska/Driftwood.jpg"}, {title:  "Flax", src: CFCDN + "Alaska/Flax.jpg"}, {title:  "Latte", src: CFCDN + "Alaska/Latte.jpg"}, {title:  "Marine", src: CFCDN + "Alaska/Marine.jpg"}, {title:  "Pewter", src: CFCDN + "Alaska/Pewter.jpg"}, {title:  "Sage", src: CFCDN + "Alaska/Sage.jpg"}, {title:  "Sand", src: CFCDN + "Alaska/Sand.jpg"}, {title:  "Thunder", src: CFCDN + "Alaska/Thunder.jpg"}]
const Galaxy = [{title: "Aquarius", src: CFCDN + "Galaxy/Aquarius.jpg"}, {title: "Astra", src: CFCDN + "Galaxy/Astra.jpg"}, {title: "Aurora", src: CFCDN + "Galaxy/Aurora.jpg"}, {title: "Bianca", src: CFCDN + "Galaxy/Bianca.jpg"}, {title: "Comet", src: CFCDN + "Galaxy/Comet.jpg"}, {title: "Dusk", src: CFCDN + "Galaxy/Dusk.jpg"}, {title: "Earth", src: CFCDN + "Galaxy/Earth.jpg"}, {title: "Halley", src: CFCDN + "Galaxy/Halley.jpg"}, {title: "Jupiter", src: CFCDN + "Galaxy/Jupiter.jpg"}, {title: "Luna", src: CFCDN + "Galaxy/Luna.jpg"}, {title: "Mars", src: CFCDN + "Galaxy/Mars.jpg"}, {title: "Mercury", src: CFCDN + "Galaxy/Mercury.jpg"}, {title: "Nebula", src: CFCDN + "Galaxy/Nebula.jpg"}, {title: "Neutron", src: CFCDN + "Galaxy/Neutron.jpg"}, {title: "Nova", src: CFCDN + "Galaxy/Nova.jpg"}, {title: "Pegasus", src: CFCDN + "Galaxy/Pegasus.jpg"}, {title: "Polar", src: CFCDN + "Galaxy/Polar.jpg"}, {title: "Saturn", src: CFCDN + "Galaxy/Saturn.jpg"}, {title: "Solar", src: CFCDN + "Galaxy/Solar.jpg"}, {title: "Twilight", src: CFCDN + "Galaxy/Twilight.jpg"}, {title: "Venus", src: CFCDN + "Galaxy/Venus.jpg"}, {title: "upiter", src: CFCDN + "Galaxy/upiter.jpg"}]
const Soleil = [{title: "Black", src: CFCDN +"Soleil/Black.jpg"}, {title: "Blush", src: CFCDN +"Soleil/Blush.jpg"}, {title: "Buff", src: CFCDN +"Soleil/Buff.jpg"}, {title: "Cement", src: CFCDN +"Soleil/Cement.jpg"}, {title: "Chalk", src: CFCDN +"Soleil/Chalk.jpg"}, {title: "Cloud", src: CFCDN +"Soleil/Cloud.jpg"}, {title: "Cobblestone", src: CFCDN +"Soleil/Cobblestone.jpg"}, {title: "Donkey", src: CFCDN +"Soleil/Donkey.jpg"}, {title: "Graphite", src: CFCDN +"Soleil/Graphite.jpg"}, {title: "Hemp", src: CFCDN +"Soleil/Hemp.jpg"}, {title: "Mint", src: CFCDN +"Soleil/Mint.jpg"}, {title: "Mist", src: CFCDN +"Soleil/Mist.jpg"}, {title: "Nugget", src: CFCDN +"Soleil/Nugget.jpg"}, {title: "Oatmeal", src: CFCDN +"Soleil/Oatmeal.jpg"}, {title: "Ocean", src: CFCDN +"Soleil/Ocean.jpg"}, {title: "Pearl", src: CFCDN +"Soleil/Pearl.jpg"}, {title: "Phantom", src: CFCDN +"Soleil/Phantom.jpg"}, {title: "Sky", src: CFCDN +"Soleil/Sky.jpg"}, {title: "Spray", src: CFCDN +"Soleil/Spray.jpg"}]
// Sheer
const Bali = [{title: "Arctic", src: CFCDN +"Bali/Arctic.jpg"}, {title: "Ash", src: CFCDN +"Bali/Ash.jpg"}, {title: "Black", src: CFCDN +"Bali/Black.jpg"}, {title: "Blush", src: CFCDN +"Bali/Blush.jpg"}, {title: "Chalk", src: CFCDN +"Bali/Chalk.jpg"}, {title: "Cloud", src: CFCDN +"Bali/Cloud.jpg"}, {title: "Cobblestone", src: CFCDN +"Bali/Cobblestone.jpg"}, {title: "Copper", src: CFCDN +"Bali/Copper.jpg"}, {title: "Denim", src: CFCDN +"Bali/Denim.jpg"}, {title: "Donkey", src: CFCDN +"Bali/Donkey.jpg"}, {title: "Driftwood", src: CFCDN +"Bali/Driftwood.jpg"}, {title: "Duckegg", src: CFCDN +"Bali/Duckegg.jpg"}, {title: "Flax", src: CFCDN +"Bali/Flax.jpg"}, {title: "Gardenia", src: CFCDN +"Bali/Gardenia.jpg"}, {title: "Heather", src: CFCDN +"Bali/Heather.jpg"}, {title: "Indigo", src: CFCDN +"Bali/Indigo.jpg"}, {title: "Mist", src: CFCDN +"Bali/Mist.jpg"}, {title: "Moss", src: CFCDN +"Bali/Moss.jpg"}, {title: "Nutmeg", src: CFCDN +"Bali/Nutmeg.jpg"}, {title: "Onyx", src: CFCDN +"Bali/Onyx.jpg"}, {title: "Pearl", src: CFCDN +"Bali/Pearl.jpg"}, {title: "Pink", src: CFCDN +"Bali/Pink.jpg"}, {title: "Rose", src: CFCDN +"Bali/Rose.jpg"}, {title: "Sage", src: CFCDN +"Bali/Sage.jpg"}, {title: "Smoke", src: CFCDN +"Bali/Smoke.jpg"}, {title: "Snow", src: CFCDN +"Bali/Snow.jpg"}, {title: "Storm", src: CFCDN +"Bali/Storm.jpg"}, {title: "Straw", src: CFCDN +"Bali/Straw.jpg"}, {title: "Taupe", src: CFCDN +"Bali/Taupe.jpg"}, {title: "Thunder", src: CFCDN +"Bali/Thunder.jpg"}]
const Vevey = [{title: "Cement", src: CFCDN + "Vevey/Cement.jpg"}, {title: "Chalk", src: CFCDN + "Vevey/Chalk.jpg"}, {title: "Cloud", src: CFCDN + "Vevey/Cloud.jpg"}, {title: "Pebble", src: CFCDN + "Vevey/Pebble.jpg"}, {title: "Pitch", src: CFCDN + "Vevey/Pitch.jpg"}, {title: "Smoke", src: CFCDN + "Vevey/Smoke.jpg"}, {title: "Straw", src: CFCDN + "Vevey/Straw.jpg"}, {title: "Vanilla", src: CFCDN + "Vevey/Vanilla.jpg"}]
const Seattle = [{title: "Biscuit", src: CFCDN +"Seattle/Biscuit.jpg"}, {title: "Blush", src: CFCDN +"Seattle/Blush.jpg"}, {title: "Cement", src: CFCDN +"Seattle/Cement.jpg"}, {title: "Chalk", src: CFCDN +"Seattle/Chalk.jpg"}, {title: "Cloud", src: CFCDN +"Seattle/Cloud.jpg"}, {title: "Denim", src: CFCDN +"Seattle/Denim.jpg"}, {title: "Diamond", src: CFCDN +"Seattle/Diamond.jpg"}, {title: "Driftwood", src: CFCDN +"Seattle/Driftwood.jpg"}, {title: "Fawn", src: CFCDN +"Seattle/Fawn.jpg"}, {title: "Flax", src: CFCDN +"Seattle/Flax.jpg"}, {title: "Graphite", src: CFCDN +"Seattle/Graphite.jpg"}, {title: "Iron", src: CFCDN +"Seattle/Iron.jpg"}, {title: "Mint", src: CFCDN +"Seattle/Mint.jpg"}, {title: "Parchment", src: CFCDN +"Seattle/Parchment.jpg"}, {title: "Pearl", src: CFCDN +"Seattle/Pearl.jpg"}, {title: "Pewter", src: CFCDN +"Seattle/Pewter.jpg"}, {title: "Sky", src: CFCDN +"Seattle/Sky.jpg"}, {title: "Sorbet", src: CFCDN +"Seattle/Sorbet.jpg"}]
export interface Fabric{
    title:string;
    src:string;
}
export interface Fabrics {
    title: string;
    id:number;
    desciption:string;
    colours:Fabric[]
    src:string;
}
export const fabricBrandBlockOut = [
    {
        title: 'Soleil ★',
        id: 6,
        desciption : "",
        colours: Soleil,
        src: CFCDN + "Soleil/Chalk.jpg",
    },
    {
        title: 'Alaska',
        id: 4,
        desciption : "",
        colours: Alaska,
        src: CFCDN + "Alaska/Ash.jpg",
    },
    {
        title: 'Galaxy',
        id: 5,
        desciption : "",
        colours: Galaxy,
        src: CFCDN + "Galaxy/Aquarius.jpg",
    }
    
]

export const fabricBrandLF = [
    {
        title: 'Seattle ★',
        id: 2,
        desciption : "",
        colours: Seattle,
        src: CFCDN + "Seattle/Cloud.jpg",
    },
    {
        title: 'Bali  ★',
        id: 0,
        desciption : "",
        colours: Bali,
        src: CFCDN + "Bali/Arctic.jpg",
    },
    {
        title: 'Vevey',
        id: 1,
        desciption : "",
        colours: Vevey,
        src: CFCDN + "Vevey/Cloud.jpg",
    }
    
    
]

export const fabricType = [
    {title:'Blockout Curtains',src:CFCDN+'Curtains/Blockout1.png',fabrics : fabricBrandBlockOut, desc: ['Great for blocking out light', 'Provides ultimate privacy','Perfect for bedroom',]},
    {title:'Sheer Curtains',src:CFCDN+'Curtains/Sheer1.png',fabrics : fabricBrandLF, desc: ['Diffuses and softens light',]},
]

export const fabricTypeDouble = [
    {title:'Double Curtains',src:CFCDN+'Curtains/Double-Curtain.png',fabrics : fabricBrandBlockOut, desc: ['Diffuses and softens light','Great for blocking out light', 'Provides ultimate privacy','Perfect for bedroom',]},
    
]

export const controlType = [
    {title: "Manual",src:CFCDN+'Curtains/Blockout1.png'},
    {title: "Motorise",src:CFCDN+'Curtains/Remote-Curtain.png'}
]


export const controlTypeDouble = [
    {title: "Manual",src:CFCDN+'Curtains/Double-Curtain.png'},
    {title: "Motorise",src:CFCDN+'Curtains/Double-Curtain-Remote.png'}
]
export const powerType = [
    {title: "Battery",src:CFCDN+'roller-blind/full-battery.png'},
    {title: "Electric",src:CFCDN+'roller-blind/power.png'}
]

export const AlphaSelection = [
    {title: "Alpha 1 Channel Remote",src:CFCDN+'protecta/control/alpha-1-channel.jpg'},
    {title: "Alpha 2 Channel Remote",src:CFCDN+'protecta/control/alpha-2-channel.jpg'},
    {title: "Alpha 5 Channel Remote",src:CFCDN+'protecta/control/alpha-5-channel.jpg'},
    {title: "Alpha 8 Channel Remote",src:CFCDN+'protecta/control/alpha-8-channel.jpg'},
    {title: "Alpha 16 Channel Remote",src:CFCDN+'protecta/control/alpha-16-channel.jpg'},
    {title: "Alpha 1 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-1-channel.jpg'},
    {title: "Alpha 2 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-2-channel.jpg'},
    {title: "Alpha 8 Channel Switch",src:CFCDN+'protecta/control/alpha-switch-8-channel.jpg'}
]
export const motoBrand = [
    {title: "ALPHA",src:CFCDN+'awning-motor-brand/alpha-square.jpg', controls: AlphaSelection},
]